export default __webpack_public_path__ + "static/media/Logo.c2039f7c.svg";